import styled from '@emotion/styled'
import { colors } from '../../tokens/colors'

export const Container = styled('div')<{
  backgroundColor?: string
  backgroundImage?: string
  height?: string
  width?: string
  isAnimationDisabled?: boolean
}>`
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};
  background-color: ${({ backgroundColor }) =>
    backgroundColor || colors.background.tertiaryBackground};

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    animation: shimmer 2s linear infinite;
    background-image: linear-gradient(
      90deg,
      rgba(246, 247, 250, 0),
      rgba(246, 247, 250, 0.4) 33%,
      rgba(246, 247, 250, 0.7) 66%,
      rgba(246, 247, 250, 0)
    );
    background-image: ${({ backgroundImage }) => backgroundImage || ''};
    ${({ isAnimationDisabled }) => !isAnimationDisabled && 'content: "";'};
  }
  @keyframes shimmer {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`
